import { render, staticRenderFns } from "./reserveServiceManageList.vue?vue&type=template&id=888a4718&scoped=true"
import script from "./reserveServiceManageList.vue?vue&type=script&lang=js"
export * from "./reserveServiceManageList.vue?vue&type=script&lang=js"
import style0 from "./reserveServiceManageList.vue?vue&type=style&index=0&id=888a4718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888a4718",
  null
  
)

export default component.exports